import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import 'bootstrap'
import '../stylesheets/application.scss';
import '../src/projects'
import '../src/home'
import '../src/lp'
import '../src/faq'
// /about 非公開中のため読み込みを止める。再公開時はコメントを外す
// import '../src/about'
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

Rails.start()
ActiveStorage.start()
window.$ = jQuery;
